import React, {createContext, useState, useContext, useEffect} from 'react';

const ContextoResumoValor = createContext(null);
const ContextoResumoAcoes = createContext(null);

export function ContextoResumoInscricaoProvider({children, valorInicial}) {
    const [dadosResumo, setDadosResumo] = useState(valorInicial);

    useEffect(() => {
        setDadosResumo(valorInicial);
    }, [valorInicial]);

    return (
        <ContextoResumoValor.Provider value={dadosResumo}>
            <ContextoResumoAcoes.Provider value={setDadosResumo}>
                {children}
            </ContextoResumoAcoes.Provider>
        </ContextoResumoValor.Provider>
    );
}

export function useContextoResumoValor() {
    return useContext(ContextoResumoValor);
}

export function useContextoResumoAcoes() {
    return useContext(ContextoResumoAcoes);
}
